import React from 'react';

const SelectionModal = ({ 
  isOpen, 
  onClose, 
  title, 
  options, 
  selectedOption, 
  onSelect 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center">
      <div className="bg-white rounded-t-xl w-full max-h-[70vh] overflow-auto">
        <div className="p-4 border-b border-gray-100">
          <div className="flex justify-between items-center">
            <button 
              className="text-gray-500"
              onClick={onClose}
            >
              取消
            </button>
            <h3 className="font-bold text-lg">{title}</h3>
            <button 
              className="text-blue-500 font-medium"
              onClick={onClose}
            >
              确定
            </button>
          </div>
        </div>
        
        <div className="p-2">
          {options.map((option) => (
            <div 
              key={option}
              className={`p-3 ${selectedOption === option ? 'text-blue-500' : 'text-gray-700'} border-b border-gray-100 flex justify-between items-center`}
              onClick={() => {
                onSelect(option);
                onClose();
              }}
            >
              <span>{option}</span>
              {selectedOption === option && (
                <i className="fa-solid fa-check text-blue-500"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectionModal;